import type { ButtonHTMLAttributes } from 'react';
import { Star } from 'lucide-react';
import styles from './FavoriteToggle.module.css';

interface FavoriteToggleProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  isFavorite: boolean;
  onToggle: () => void;
}

export const FavoriteToggle = ({
  isFavorite,
  onToggle,
  className = '',
  ...props
}: FavoriteToggleProps) => {
  const classNames = [
    styles.toggle,
    isFavorite && styles.active,
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      type="button"
      className={classNames}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
      aria-pressed={isFavorite}
      {...props}
    >
      <Star 
        size={20} 
        fill={isFavorite ? 'currentColor' : 'none'}
        strokeWidth={isFavorite ? 0 : 2}
      />
    </button>
  );
};

